import { Flex, chakra, Text } from "@chakra-ui/react";
import {FC, memo} from "react";
import { useTranslation } from "react-i18next";
import { useColorModeValue } from "../ui/color-mode";

type Props = {
}

export const Footer: FC<Props> = memo((props) => {
    const {t} = useTranslation();
    const bg = useColorModeValue("gray.100", "gray.800");
    return (
        <Flex
            w="full"
            alignItems="center"
            justifyContent="center"
            >
            <Flex
                w="full"
                as="footer"
                flexDir={{
                base: "column",
                sm: "row",
                }}
                align="center"
                justify="space-between"
                px="6"
                py="4"
                bg={bg}
            >
                <chakra.a
                href="/"
                fontSize="xl"
                fontWeight="bold"
                color="gray.600"
                _dark={{
                    color: "white",
                    _hover: {
                    color: "gray.300",
                    },
                }}
                _hover={{
                    color: "gray.700",
                }}
                >
                {t("app")}
                </chakra.a>

                <chakra.p
                py={{
                    base: "2",
                    sm: "0",
                }}
                color="gray.800"
                _dark={{
                    color: "white",
                }}
                >
                {t("copyright.text")}
                </chakra.p>

                <Flex mx="-2">
                    <Text>{t("version")}</Text>
                </Flex>
            </Flex>
        </Flex>
    );
});